import { render, staticRenderFns } from "./invoice-card.vue?vue&type=template&id=efb86dd4&scoped=true&"
import script from "./invoice-card.vue?vue&type=script&lang=js&"
export * from "./invoice-card.vue?vue&type=script&lang=js&"
import style0 from "./invoice-card.vue?vue&type=style&index=0&id=efb86dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb86dd4",
  null
  
)

export default component.exports